import { config } from './utils';

const money = amount => {
    if ( config.country === 'co' ) {
        return '$' + ( new Intl.NumberFormat( 'es-CO', { style: 'decimal', maximumFractionDigits: 0} ).format( amount ) );
    } else if ( config.country === 'mx' ) {
        return '$' + ( new Intl.NumberFormat( 'es-MX', { style: 'decimal', maximumFractionDigits: 0} ).format( amount ) );
    }
    return new Intl.NumberFormat( config.country, { style: 'currency', currency: config.currency } ).format( amount );
}

const moneyToInt = (money, defaultValue = 0) => {
    if (typeof money !== 'string' || !money.length) return defaultValue;
    
    const cleanedValue = money.replace(/[$,.]/g, '');
    const parsedValue = parseInt(cleanedValue, 10);

    if (isNaN(parsedValue)) return defaultValue;
  
    return parsedValue;
  };
  

export { money, moneyToInt }